module.exports = __webpack_public_path__ + "img/client-takeout_en.bfd3bd27.svg";